import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Table, TableCell, TableBody, TableRow, TableHead } from '@mui/material';
import EngineExternalSystemListItemComponent from './EngineExternalSystemListItemComponent';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const EngineExternalSystemListComponent = ({
  externalSystems,
  dictionaryExternalSystemInterrogation,
  containerDispatcher,
  isReadOnly,
  validation
}) => {
  const { t } = useTranslation();
  return (
    <Grid item>
      <CardNoResultsWrapper content={externalSystems?.engineExternalSystems}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('EngineScoring.EngineScoringXExternalSystems.ExternalSystem')}</TableCell>
              <TableCell>{t('EngineScoring.EngineScoringXExternalSystems.Mandatory')}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {externalSystems.engineExternalSystems.map((item, idx) => {
              return (
                <EngineExternalSystemListItemComponent
                  item={item}
                  key={idx}
                  index={idx}
                  containerDispatcher={containerDispatcher}
                  dictionaryExternalSystemInterrogation={dictionaryExternalSystemInterrogation}
                  isReadOnly={isReadOnly}
                  validation={validation[idx]}
                />
              );
            })}
          </TableBody>
        </Table>
      </CardNoResultsWrapper>
    </Grid>
  );
};

EngineExternalSystemListComponent.propTypes = {
  dictionaryExternalSystemInterrogation: PropTypes.array.isRequired,
  externalSystems: PropTypes.object.isRequired,
  containerDispatcher: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  validation: PropTypes.object.isRequired
};

export default EngineExternalSystemListComponent;
